/* eslint-disable no-native-reassign, no-shadow, react/prop-types, react/jsx-no-bind */
import React, { Component } from 'react';
import { connect } from 'react-redux';
import { bindActionCreators } from 'redux';
import { facebookLoad, facebookResponse } from 'es6/redux/modules/auth/facebook';
import { login } from 'es6/services/facebook';
import { facebook } from 'es6/core/paths';
import OauthButton from 'es6/components/registration/oauth/oauth-button';
import Providers from 'es6/core/oauth-providers';
import { getFacebook } from 'es6/helpers/selectors';

function mapStateToProps(state) {
  return getFacebook(state);
}

function mapDispatchToProps(dispatch) {
  const actionCreators = { facebookLoad, onFacebookResponse: facebookResponse };
  return bindActionCreators(actionCreators, dispatch);
}

/**
 * @this FacebookOauthButton
 * @param {Object} response         response returned from facebook
 */
function handleFacebookResponse(response) {
  this.props.onFacebookResponse(response);

  if (response.status === 'connected') {
    location = facebook();
  }
}

class FacebookOauthButton extends Component {
  componentWillMount() {
    const { facebookLoad, isLoaded } = this.props;

    if (!isLoaded) {
      facebookLoad();
    }
  }

  render() {
    const { children, isLoaded } = this.props;
    const isLoading = !isLoaded;
    const onClick = () => isLoaded && login(handleFacebookResponse.bind(this));

    return (
      <OauthButton provider={Providers.FACEBOOK} isLoading={isLoading} onClick={onClick}>
        {children}
      </OauthButton>
    );
  }
}

export default connect(mapStateToProps, mapDispatchToProps)(FacebookOauthButton);
